export const listDifference = (listA, listB, propertySelectorForComparison) => {
    const propertiesA = listA.map(propertySelectorForComparison);
    const propertiesB = listB.map(propertySelectorForComparison);
    const onlyInA = propertiesA.filter(x => !propertiesB.includes(x));
    return listA.filter(item => {
        const prop = propertySelectorForComparison(item);
        return onlyInA.includes(prop);
    });
};
